import { useState, useEffect, useContext } from "react";
import Context from "../../storage/context";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CarCardEdit from "../CarCardEdit/CarCardEdit"
import useAdminAuth from "../../hooks/useAdminAuth/useAdminAuth";

const AdminPage = () => {
    let ctx = useContext(Context);
    let [protect, setProtect] = useState(false);
    let CARS = ctx.getAllCars;
    let navigate = useNavigate();

    useAdminAuth(ctx.api_url, setProtect);

    const onAdd = () => {
        localStorage.removeItem("car");
        navigate("/new", { replace: true });
    }


    useEffect(() => {
        const fetchCars = async () => {
            try {
                const res = await axios.get(`${ctx.api_url}/cars`);
                ctx.setAllCars(res.data);
            } catch (error) {
                console.error("אופס, הלך המנוע (שגיאה בטעינת הרכבים):", error);
            }
        };

        fetchCars();
    }, [ctx.delete_car]);


    // useEffect(() => {
    //     const data = async () => {
    //         let res = { data: { message: "" } }
    //         if (localStorage.getItem("token") === null) {
    //             res.data.message = "no access"
    //         } else {

    //             try {
    //                 res = await axios.get(`${ctx.api_url}/profile`, {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem("token")}`
    //                     }
    //                 });
    //             } catch (err) {
    //                 res.data.message = "no access"
    //             }
    //         }
    //         if (res.data.message === "Protected data") {
    //             setProtect(protect + 2)
    //         } else {
    //             setProtect(protect + 1);
    //         }
    //     }
    //     data();
    // }, [])


    return protect && (
        <section className="section">
            <div className="section-inner">
                <div className="cars-header">
                    <div>
                        <div className="section-tag">דף ניהול</div>
                        <p className="section-sub" style={{ marginBottom: 0 }}>בדף זה ניתן להוסיף, למחוק, ולערוך רכבים. </p>
                    </div>
                    <button className="btn-ghost" onClick={onAdd}>הוסף רכב חדש +</button>
                </div>


                <div className="cars-grid">
                    {CARS.map(car => (
                        <CarCardEdit data={car} key={car.car_id} />
                    ))}
                </div>
            </div>
        </section>
    );
};


export default AdminPage;